<template>
  <div class="b-layout">
    <div class="bg-white b-layout__wrapper p-5 border shadow-lg rounded">
      <div class="text-center pb-5">
        <Link href="/">
          <img
            src="@assets/logo.svg"
            alt=""
          >
        </Link>
      </div>
      <slot />
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3';

export default {
  name: 'GuestLayout',
  components: { Link },
};
</script>

<style scoped lang="scss">

  .b-layout {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;

    &__wrapper {
      width: 500px;
    }
  }
</style>
